module.exports = __webpack_public_path__ + "static/media/logo-svg.26f87bca.svg";